import { generateCopilotRules } from "./copilot.js";

/**
 * Generate Cline rules (~12KB).
 * Same content as Copilot.
 */
export function generateClineRules(): string {
  return generateCopilotRules();
}
